import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CitizenPortal() {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [data, setData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/auth/user`,
          {
            credentials: "include",
          }
        );
        const result = await res.json();
        console.log("📦 Response:", result);

        if (!result.success) throw new Error("Failed to load user data");

        const { status, userData, applicationData, message, rejectionReason, applicationNumber, submittedDate, expiryDate, passportNumber } = result;
        setStatus(status);
        setData({ userData, applicationData });
        const paymentStatus = applicationData?.payment_status?.toLowerCase();
        console.log("💳 Payment Status from DB:", paymentStatus);

        // if (applicationData?.payment_status === 'pending' || applicationData?.payment_status === 'failed') {
        //   console.log("💳 Redirecting to payment due to payment status:", applicationData.payment_status);
        //   navigate("/passport/payment", {
        //     state: {
        //       applicationData: applicationData,
        //       userData: userData,
        //       paymentStatus: applicationData.payment_status
        //     }
        //   });
        //   return;
        // }

        // Route logic
        switch (status) {
          case "no_application":
            // No application data to pass
            navigate("/apply", {
              state: { isRenewal: false, renewalData: null },
            });
            break;

          case "approved_can_renew":
            // Pass both user and application data for renewal
            navigate("/passport/status/renewal", {
              state: {
                isRenewal: true,
                renewalData: { applicationData, userData },
              },
            });
            break;

          case "approved_no_renew":
            // Pass application data to approved page
            navigate("/passport/status/approved", {
              state: {
                title: "Passport Valid",
                message: message,
                applicationData: applicationData,
                userData: userData,
                expiryDate: expiryDate,
                passportNumber: passportNumber
              },
            });
            break;

          case "rejected":
            // Pass user and application data to rejected page
            navigate("/passport/status/rejected", {
              state: {
                userData: userData,
                applicationData: applicationData,
                reason: rejectionReason,
                applicationId: applicationData?.id || applicationData?.application_id
              },
            });
            break;

          case "under_renewal":
          case "under_verification":
          case "pending":
            // Check payment status for under_verification/pending applications
            if (paymentStatus === 'pending' || paymentStatus === 'failed') {
              console.log("💳 Redirecting to payment page");
              console.log("   - Payment Status:", paymentStatus);
              console.log("   - Application Status:", status);

              // Navigate with consistent data structure
              navigate("/passport/payment", {
                state: {
                  data: applicationData, // Add this for StepPayment compatibility
                  applicationData: applicationData,
                  userData: userData,
                  paymentStatus: paymentStatus,
                  applicationNumber: applicationNumber
                }
              });
            } else {
              // Payment is complete, show verification status
              console.log("➡️ Navigating to passport/status/pending");
              navigate("passport/status/pending", {
                state: {
                  title: "Application Under Verification",
                  message: message,
                  applicationNumber: applicationNumber,
                  submittedDate: submittedDate,
                  applicationData: applicationData,
                  userData: userData
                },
              });
            }
            break;

          default:
            // Fallback with all available data
            navigate("/apply", {
              state: {
                title: "Status",
                message: `Application status: ${status}`,
                applicationData: applicationData,
                userData: userData
              },
            });
        }
      } catch (err) {
        console.error("❌ Error loading user data:", err);
        navigate("/error");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-lg font-medium text-gray-700">
        Loading your application status...
      </div>
    );
  }

  return null;
}